//TextField
import React, { Component } from "react";
import SearchBar from "material-ui-search-bar";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import ClearIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const styles = (theme) => ({
  SearchBar: {
    height: "46px",
    border: "1px solid #E3E3E3",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px",

    "& .MuiInputBase-input": {
      fontFamily: theme.fontFamilyCenturyGothic,
      color: "#000000B2",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#000000B2",
      opacity: 1
    },
  },
  searchIcon: {
    color: "grey",
    height: "25px",
    padding: "0px",
  },
  closeIcon: {
    color: "#000",
  },
});



class MyNewSearchBar extends Component {
  render() {
    const { classes } = this.props;
    return (
      <SearchBar
        placeholder={this.props.placeholder}
        className={classes.SearchBar}
        inputProps={{
          startAdornment: <SearchIcon className={classes.searchIcon} />
        }}
        closeIcon={
          <IconButton size="small" className={classes.closeIcon}>
            <ClearIcon onClick={this.props.clearSearch} />
          </IconButton>
        }
        value={this.props.value}
        onChange={(value) => {
          this.props.handleSearch(value);
        }}
      />
    );
  }
}


export default withStyles(styles)(MyNewSearchBar);
